'use strict';
const $ = (window.jQuery = window.$ = require('jquery'));

let Selector = {
  component: '.js-fast-paste',
  input: '.js-input',
  inputTrigger: '.js-fast-paste-trigger',
  fakeInputOne: '.js-fake-code1',
  fakeInputTwo: '.js-fake-code2',
  fakeInputThree: '.js-fake-code3'
};

// Handle autofocus on next input
const inputs = document.querySelectorAll('.auto-next-input');
inputs.forEach((input, index) => {
  input.addEventListener('input', () => {
    const currentLength = input.value.length;
    const maxLength = input.maxLength;

    if (currentLength >= maxLength && inputs[index + 1]) {
      inputs[index + 1].focus();
    }
  });
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Backspace' && input.value.length === 0 && inputs[index - 1]) {
      inputs[index - 1].focus();
    }
  });
});

let bindEvent = () => {
  console.log('Fast paste activeted');

  $(Selector.input).on('focus', (e) => {
    $(e.currentTarget).attr('placeholder', '');
  });

  $(Selector.input).on('blur', (e) => {
    if ($(e.currentTarget).hasClass('js-fast-paste-trigger')) {
      $(e.currentTarget).attr('placeholder', 'XXX');
    } else if ($(e.currentTarget).hasClass('js-fast-paste-zeros')) {
      $(e.currentTarget).attr('placeholder', '0000');
    } else {
      $(e.currentTarget).attr('placeholder', 'XXXX');
    }
  });

  $(`${Selector.fakeInputOne}, ${Selector.fakeInputTwo}, ${Selector.fakeInputThree}`).on('keyup', (e) => {
    let value = $(e.currentTarget).val();
    if (value !== value.toUpperCase()) {
      $(e.currentTarget).val(value.toUpperCase());
    }
  });

  $(Selector.inputTrigger).on('paste', (e) => {
    const pastedText = (e.originalEvent.clipboardData || window.clipboardData).getData('text').trim().toUpperCase();
    const parts = pastedText.split('-');

    if (parts.length === 3) {
      e.preventDefault();
      $(Selector.fakeInputOne).val(parts[0].substring(0, 3));
      $(Selector.fakeInputTwo).val(parts[1].substring(0, 4));
      $(Selector.fakeInputThree).val(parts[2].substring(0, 4));
      $(Selector.fakeInputThree).trigger('focus');
    } else if (pastedText.length > 3) {
      // Codice senza separatori: es. "XXXYYYYZZZZ"
      e.preventDefault();
      const raw = pastedText.replace(/-/g, '');
      $(Selector.fakeInputOne).val(raw.substring(0, 3));
      $(Selector.fakeInputTwo).val(raw.substring(3, 7));
      $(Selector.fakeInputThree).val(raw.substring(7, 11));
      $(Selector.fakeInputThree).trigger('focus');
    }
  });
};

module.exports = function() {
  if ($(Selector.component).length) {
    bindEvent();
  }
};
